<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field outlined hide-details :rules="[ v => (v.length <= 100) || $t('eventoption_label1') ]" 
                  v-model="editedItem.NAME" :label="$t('eventoption_col3')"></v-text-field>
              </v-row>
              <v-row dense class="mt-3"> 
                <v-text-field outlined hide-details :rules="[ v => (v.length <= 100) || $t('eventoption_label1') ]" 
                  v-model="editedItem.NAME_ENG" :label="$t('eventoption_col15')"></v-text-field>
              </v-row>
              <v-row class="mt-2">
                <v-col md="12" sm="12" xs="12">
                <v-select outlined hide-details v-model="editedItem.STATE" :items="STATELIST" :label="$t('eventoption_col2')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                <v-select outlined hide-details v-model="editedItem.COST_TYPE" :items="COSTLIST" :label="$t('eventoption_col1')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" @change="change_costtype"/>
                </v-col>
              </v-row>

              <v-row >
                <v-col md="12" sm="12" xs="12">
                  <v-select outlined hide-details v-model="editedItem.USE_LIMIT" :items="STATELIST" :label="$t('eventoption_col13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
                <v-col md="12" sm="12" xs="12" v-if="editedItem.USE_LIMIT == 1">
                  <v-text-field type="number" outlined hide-details
                    v-model="editedItem.LIMIT_CNT" :label="$t('eventoption_col13')" counter="10"
                  ></v-text-field>                  
                </v-col>
              </v-row>

              <v-row >
                <v-col md="12" sm="12" xs="12">
                  <v-select outlined hide-details v-model="editedItem.USE_QRLIMIT" :items="STATELIST" :label="$t('eventoption_col14')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
                <v-col md="12" sm="12" xs="12" v-if="editedItem.USE_QRLIMIT == 1">
                  <v-text-field type="number" outlined hide-details
                    v-model="editedItem.QRLIMIT_CNT" :label="$t('eventoption_col14')" counter="10"
                  ></v-text-field>                  
                </v-col>
              </v-row>

              <v-row dense v-if="editedItem.COST_TYPE == 1">
                <v-col cols="12" class="d-flex">
                  <v-checkbox dense :label="$t('eventoption_col10')" v-model="editedItem.USE_WON" hide-details class="ma-0 pa-0"/>
                  <v-checkbox dense :label="$t('eventoption_col11')" v-model="editedItem.USE_USD" hide-details class="ma-0 pa-0 ml-2"/>
                </v-col>
              </v-row>

              <v-row  v-if="editedItem.COST_TYPE == 1">
                <v-col cols="12">
                  <v-text-field 
                    type="number" outlined hide-details :disabled="editedItem.USE_WON == 0"
                    v-model="editedItem.COST" :label="$t('eventoption_col4')" counter="10"
                  ></v-text-field>
                  <!-- :rules="[  v => (v.length <= 10) || '10자 까지 입력이 가능합니다.', , v => v || /[0-9]/.test(v) || '숫자만 입력가능합니다.']" -->
                </v-col>
              </v-row>

              <v-row v-if="editedItem.COST_TYPE == 1">
                <v-col md="12" sm="12" xs="12">
                  <v-text-field 
                    type="number" outlined :disabled="editedItem.USE_USD == 0" hide-details
                    v-model="editedItem.COST_USD" :label="$t('eventoption_col9')" counter="10"
                  ></v-text-field>
                  <!-- :rules="[  v => (v.length <= 10) || '10자 까지 입력이 가능합니다.', , v => v || /[0-9]/.test(v) || '숫자만 입력가능합니다.']" -->
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="5">
                  <label style="margin:10px; text-align:right">{{$t('eventoption_col5')}}</label>
                </v-col>
                <v-col cols="6">
                  <datetime input-style="margin-left:10px; width:150px; border-bottom:1px solid gray; text-align:left; font-size:16px" 
                            type="datetime" format="yyyy-MM-dd HH:mm" :title="$t('eventoption_col5')" 
                            v-model="editedItem.REG_START" />
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="5">
                  <label style="margin:10px; text-align:right">{{$t('eventoption_col6')}}</label>
                </v-col>
                <v-col cols="6">
                  <datetime input-style="margin-left:10px; width:150px; border-bottom:1px solid gray; text-align:left; font-size:16px" 
                            type="datetime" format="yyyy-MM-dd HH:mm" :title="$t('eventoption_col6')"
                            v-model="editedItem.REG_END"/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col md="12" sm="12" xs="12">
                  <v-col md="12" sm="12" xs="12">
                    <v-select outlined hide-details v-model="editedItem.VISIBLE" :items="VISIBLELIST" :label="$t('eventoption_label2')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                  </v-col>
                </v-col>
              </v-row>

              <!-- 
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field 
                    type="number"  dense clearable
                    v-model="editedItem.SORT" label="정렬" counter="2"
                  ></v-text-field>
                </v-col>
              </v-row>
              -->
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense align="center">
      <v-col cols="12" md="2" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>

      <template v-if="grade >= 50">
        <v-col cols="12" offset-md="1" md="3" sm="12" xs="12" class="pa-0">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <template v-else>
        <v-spacer/>
      </template>

      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">        
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="yellow_btn_freesize" elevation="0" outlined large @click="saveSort">{{$t("eventoption_label3")}}</v-btn>        
      </v-col>

    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12">
        <label style="color:red">{{$t("eventoption_label4")}}</label>
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <draggable v-model="itemList">
        <v-data-table
          :headers="headers"
          :items="itemList"
          :no-data-text="$t('common_nodata')"
          hide-default-footer
          
          class="datatablestyle"
          item-key="IDX"
          :loading="loading"
          :items-per-page="9999"
          v-model="selected"
          >
          <template v-slot:header.IDX>
            <label class="cheader_normal" >{{$t("eventoption_col12")}}</label>
          </template>
          <template v-slot:header.COST_TYPE>
            <label class="cheader_normal" >{{$t("eventoption_col1")}}</label>
          </template>
          <template v-slot:header.STATE>
            <label class="cheader_normal" >{{$t("eventoption_col2")}}</label>
          </template>
          <template v-slot:header.VISIBLE>
            <label class="cheader_normal" >{{$t("eventoption_col8")}}</label>
          </template>
          <template v-slot:header.NAME>
            <label class="cheader_normal" >{{$t("eventoption_col3")}}</label>
          </template>
          <template v-slot:header.NAME_ENG>
            <label class="cheader_normal" >{{$t("eventoption_col15")}}</label>
          </template>
          <template v-slot:header.COST>
            <label class="cheader_normal" >{{$t("eventoption_col4")}}</label>
          </template>
          <template v-slot:header.COST_USD>
            <label class="cheader_normal" >{{$t("eventoption_col9")}}</label>
          </template>
          <template v-slot:header.REG_START>
            <label class="cheader_normal" >{{$t("eventoption_col5")}}</label>
          </template>
          <template v-slot:header.REG_END>
            <label class="cheader_normal" >{{$t("eventoption_col6")}}</label>
          </template>
          <template v-slot:header.actions>
            <label class="cheader_normal" >{{$t("eventoption_col7")}}</label>
          </template>
          <template v-slot:body="props">
            <draggable :list="props.items" ghost-class="ghost" @change="changedrag" tag="tbody">
              <tr v-for="(item, index) in props.items" :key="index">
                <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
                <td style="width:100px; text-align:center">{{ item.IDX }}</td>
                <td style="width:80px; text-align:center">{{ item.COST_TYPE == 1 ? $t('eventoption_label5') : $t('eventoption_label6') }}</td>
                <td style="width:80px; text-align:center">{{ item.STATE == 1 ? $t('eventoption_label7') : $t('eventoption_label8') }}</td>
                <td style="width:80px; text-align:center">{{ item.VISIBLE == 1 ? $t('eventoption_label9') : $t('eventoption_label10') }}</td>
                <td style="width:200px; text-align:center">{{ item.NAME }}</td>
                <td style="width:200px; text-align:center">{{ item.NAME_ENG }}</td>
                <td style="width:100px; text-align:center">{{ item.USE_LIMIT == 1 ? $t('eventlist_value3') : $t('eventlist_value4') }}</td>
                <td style="width:100px; text-align:center">{{ item.USE_QRLIMIT == 1 ? $t('eventlist_value3') : $t('eventlist_value4') }}</td>
                <td style="width:80px; text-align:center">{{ priceToString(item.COST) }}</td>
                <td style="width:80px; text-align:center">{{ priceToString(item.COST_USD) }}</td>
                <td style="width:100px; text-align:center">{{ item.REG_START }}</td>
                <td style="width:100px; text-align:center">{{ item.REG_END }}</td>
                <td style="width:80px; text-align:center"><v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon><v-icon small @click="delete_item(item)">mdi-delete</v-icon></td>
              </tr>
            </draggable>
          </template>


        

        </v-data-table>
      </draggable>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import dateFormat from 'dateformat'
import moment from 'moment'
import draggable from 'vuedraggable'

export default {

    components: {
            draggable,
    },

    data: () => ({

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          NAME:'',
          NAME_ENG:'',
          STATE:1,
          VISIBLE:1,
          COST_TYPE:1,
          SORT:1,
          COST:0,
          COST_USD:0,
          USE_WON:1,
          USE_USD:1,
          USE_LIMIT:0,
          LIMIT_CNT:1000,
          USE_QRLIMIT:0,
          QRLIMIT_CNT:500,
          REG_START: dateFormat(new Date(), "yyyy-mm-dd 09:00"),
          REG_END: dateFormat(new Date(), "yyyy-mm-dd 18:00"),
      },
      editedItem: {
      },
      selected:[],              //테이블에 선택된 아이템 리스트

      //테이블 정의
      headers: [
        {text: '', value: '', sortable: false, align:'center', width:'50px'},
        {text: 'IDX', value: 'IDX', sortable: true, align:'center'},
        {text: '구분', value: 'COST_TYPE', sortable: true, align:'center'},
        {text: '상태', value: 'STATE', sortable: true, align:'center'},
        {text: '구분', value: 'VISIBLE', sortable: true, align:'center'},
        {text: '등록 카테고리', value: 'NAME', sortable: true, align:'center' },
        {text: '등록 카테고리(영문)', value: 'NAME_ENG', sortable: true, align:'center' },
        {text: '선착순', value: 'USE_LIMIT', sortable: true, align:'center'},
        {text: 'QR제한', value: 'USE_QRLIMIT', sortable: true, align:'center'},
        {text: '원화', value: 'COST', sortable: true, align:'center'},
        {text: '달러', value: 'COST_USD', sortable: true, align:'center'},
        {text: '접수 시작일시', value: 'REG_START', sortable: true, align:'center'},
        {text: '접수 종료일시', value: 'REG_END', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      STATELIST: [
          {name:'비활성', name2:"Disable", value:0}
        , {name:'활성', name2:"Enable", value:1}
      ],

      COSTLIST: [
          {name:'무료', name2:"Free", value:0}
        , {name:'유료', name2:"Charged", value:1}
      ],

      VISIBLELIST: [
          {name:'초청장 전용 입장권', name2:"Invitation", value:0}
        , {name:'일반 입장권', name2:"General", value:1}
      ],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',

      grade : 0,

    }),


    beforeRouteLeave (to, from, next) {

      if(this.itemList.length > 0){
        var checkflag = false;
        for(var i=0;i<this.itemList.length;i++){
          var element = this.itemList[i];
          if(element.SEQ != i){
            checkflag = true;
            break;
          }
       }

       if(checkflag){
        this.$confirm(this.$t("eventoption_msg1"))
        .then(() => {
          next();
        });
       }else{
        next(); 
       }
      }else{
        next();
      }
    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
      

    },

    create(){

    },

    methods: {

      saveSort(){

        if(this.itemList.length <= 1){
          this.$alert(this.$t('eventoption_msg2'));
          return;
        }

        //드래그앤드랍 순서를 저장한다.
        this.$confirm(this.$t('eventoption_msg13'))
        .then(() => {

          var tempidx = 1;
          this.itemList.forEach(item=>{
            item.SORT = tempidx;
            tempidx++;
          });

          this.loading = true;
          this.$http.post(this.$host+'/api/EventOptionUpdateSort',
            {
              SORTDATA: escape(JSON.stringify(this.itemList))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('eventoption_msg14')).then(()=>{
                  this.loadpage();
                });
  

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_sort_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t('common_sort_fail'));
          });

        });
      },          

      //오리지널 리스트 순서를 변경
      changedrag(e){
        this.itemList.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.itemList.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },

      priceToString(price) {
        if(price == null || price == undefined){
          return "0";
        }
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },

      //행사 유료/무료 변경시
      change_costtype(select){
        if(select == 0){
          //무료면 가격을 강제로 변경한다.
          this.editedItem.COST = 0;
        }
      },

      // eslint-disable-next-line no-unused-vars
      visibilityChanged (isVisible, entry) {
        //console.log("visibilityChanged 1 " + isVisible + " / " + entry);
      },

      loadpage(){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;

          this.$http.post(this.$host+'/api/EventOptionList',{
                COMIDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                var index = 0;
                list.forEach(element => {
                    element.SEQ = index;
                    index++;
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t("eventoption_msg3"));
          return;
        } 
        if(this.editedItem.NAME_ENG  == undefined || this.editedItem.NAME_ENG.length < 1){
          this.$alert(this.$t("eventoption_msg19"));
          return;
        } 

        const reg_start = new Date(this.editedItem.REG_START)
        const reg_end   = new Date(this.editedItem.REG_END)
        if(reg_start > reg_end){
          this.$alert(this.$t("eventoption_msg4"));
          return;
        }


        if(this.editedItem.NAME.length > 100){
          this.$alert(this.$t("eventoption_msg5"));
          return;
        } 
        if(this.editedItem.NAME_ENG.length > 100){
          this.$alert(this.$t("eventoption_msg20"));
          return;
        } 
        if(this.editedItem.REG_START == undefined || this.editedItem.REG_START.length < 1){
          this.$alert(this.$t("eventoption_msg6"));
          return;
        } 
        if(this.editedItem.REG_END == undefined || this.editedItem.REG_END.length < 1){
          this.$alert(this.$t("eventoption_msg7"));
          return;
        } 

        if(this.editedItem.USE_LIMIT == 1){
          if(this.editedItem.LIMIT_CNT == null || this.editedItem.LIMIT_CNT == undefined || this.editedItem.LIMIT_CNT == 0){
            this.$alert(this.$t("eventoption_msg17"));
            return;
          }
        }

        if(this.editedItem.USE_QRLIMIT == 1){
          if(this.editedItem.QRLIMIT_CNT == null || this.editedItem.QRLIMIT_CNT == undefined || this.editedItem.QRLIMIT_CNT == 0){
            this.$alert(this.$t("eventoption_msg18"));
            return;
          }
        }

        if(this.editedItem.COST_TYPE == 1){

          //유료결제
          if(this.editedItem.USE_WON){
            //원화결제 사용시
            if(this.editedItem.COST == null || this.editedItem.COST == undefined || this.editedItem.COST == 0){
              this.$alert(this.$t("eventoption_msg8"));
              return;
            }
            if(this.editedItem.COST.length > 10){
              this.$alert(this.$t("eventoption_msg9"));
              return;
            }
            if(this.editedItem.COST < 1000){
              this.$alert(this.$t("eventoption_msg10"));
              return;
            }
          }

          if(this.editedItem.USE_USD){
            //달러결제 사용시
            if(this.editedItem.COST_USD == null || this.editedItem.COST_USD == undefined || this.editedItem.COST_USD == 0){
              this.$alert(this.$t("eventoption_msg16"));
              return;
            }
            if(this.editedItem.COST_USD.length > 10){
              this.$alert(this.$t("eventoption_msg9"));
              return;
            }
            if(this.editedItem.COST_USD < 1){
              this.$alert(this.$t("eventoption_msg15"));
              return;
            }
          }

        }

        if(this.editedItem.SORT  == undefined || this.editedItem.SORT.length < 1){
          this.$alert(this.$t("eventoption_msg11"));
          return;
        } 
        if(this.editedItem.SORT.length > 2){
          this.$alert(this.$t("eventoption_msg12"));
          return;
        } 

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EventOptionUpdate',{
                IDX: this.editedItem.IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
              , COMIDX: this.editedItem.COMIDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , NAME: escape(this.editedItem.NAME)
              , NAME_ENG: escape(this.editedItem.NAME_ENG)
              , STATE: this.editedItem.STATE
              , COST_TYPE: this.editedItem.COST_TYPE
              , COST: this.editedItem.COST == undefined || this.editedItem.COST.length < 1 || this.editedItem.COST == 0 ? 0 : this.editedItem.COST
              , COST_USD: this.editedItem.COST_USD == undefined || this.editedItem.COST_USD.length < 1 || this.editedItem.COST_USD == 0 ? 0 : this.editedItem.COST_USD
              , USE_LIMIT: this.editedItem.USE_LIMIT
              , LIMIT_CNT: this.editedItem.LIMIT_CNT == undefined || this.editedItem.LIMIT_CNT.length < 1 || this.editedItem.LIMIT_CNT == 0 ? 0 : this.editedItem.LIMIT_CNT
              , USE_QRLIMIT: this.editedItem.USE_QRLIMIT
              , QRLIMIT_CNT: this.editedItem.QRLIMIT_CNT == undefined || this.editedItem.QRLIMIT_CNT.length < 1 || this.editedItem.QRLIMIT_CNT == 0 ? 0 : this.editedItem.QRLIMIT_CNT
              , USE_WON: this.editedItem.USE_WON
              , USE_USD: this.editedItem.USE_USD
              , VISIBLE: this.editedItem.VISIBLE
              , REG_START: dateFormat(this.editedItem.REG_START, "yyyy-mm-dd HH:MM")
              , REG_END: dateFormat(this.editedItem.REG_END, "yyyy-mm-dd HH:MM")
              , SORT: this.editedItem.SORT
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EventOptionInsert',{
                COMIDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , NAME: escape(this.editedItem.NAME)
              , NAME_ENG: escape(this.editedItem.NAME_ENG)
              , STATE: this.editedItem.STATE
              , COST_TYPE: this.editedItem.COST_TYPE
              , COST: this.editedItem.COST == undefined || this.editedItem.COST.length < 1 || this.editedItem.COST == 0 ? 0 : this.editedItem.COST
              , COST_USD: this.editedItem.COST_USD == undefined || this.editedItem.COST_USD.length < 1 || this.editedItem.COST_USD == 0 ? 0 : this.editedItem.COST_USD
              , USE_LIMIT: this.editedItem.USE_LIMIT
              , LIMIT_CNT: this.editedItem.LIMIT_CNT == undefined || this.editedItem.LIMIT_CNT.length < 1 || this.editedItem.LIMIT_CNT == 0 ? 0 : this.editedItem.LIMIT_CNT
              , USE_QRLIMIT: this.editedItem.USE_QRLIMIT
              , QRLIMIT_CNT: this.editedItem.QRLIMIT_CNT == undefined || this.editedItem.QRLIMIT_CNT.length < 1 || this.editedItem.QRLIMIT_CNT == 0 ? 0 : this.editedItem.QRLIMIT_CNT
              , USE_WON: this.editedItem.USE_WON
              , USE_USD: this.editedItem.USE_USD
              , VISIBLE: this.editedItem.VISIBLE
              , REG_START: dateFormat(this.editedItem.REG_START, "yyyy-mm-dd HH:MM")
              , REG_END: dateFormat(this.editedItem.REG_END, "yyyy-mm-dd HH:MM")
              , SORT: this.editedItem.SORT
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('common_insert_msg')).then(()=>{
                this.loadpage();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){
        
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem);

        this.editedItem.REG_START   = moment(this.editedItem.REG_START).format("YYYY-MM-DDTHH:mm");
        this.editedItem.REG_END     = moment(this.editedItem.REG_END).format("YYYY-MM-DDTHH:mm");

        this.editedItem.SORT        = parseInt(this.itemList.length+1);
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        //포커스 클리어 필요.
        
        

        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        this.editedItem = Object.assign({}, item);
        this.editedItem.REG_START   = moment(item.REG_START).format("YYYY-MM-DDTHH:mm");
        this.editedItem.REG_END     = moment(item.REG_END).format("YYYY-MM-DDTHH:mm");
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventOptionDelete',{
                IDX:item.IDX            
              , ADMIN_IDX: item.ADMIN_IDX
              , COMIDX: item.COMIDX
              , EVENT_IDX: item.EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },


      //행사날자 선택 콜백
      select_scheduledate(var1){
        this.editedItem.SCHEDULE_DATE = var1;
      },

      select_starttime(var1){
        this.editedItem.START_TIME = moment(var1).format("HH:mm");
      },

      select_endtime(var1){
        this.editedItem.END_TIME = moment(var1).format("HH:mm");
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>





   
</style>